import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  containerType: {
    name: '',
    description: '',
    code: '',
    status: true,
  },
};

export const createContainerType = createSlice({
  name: 'createContainerType',
  initialState,
  reducers: {
    updateContainerTypeInfo: (state, action) => {
      state.containerType = action.payload;
    },
    updateContainerTypeInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.containerType[field] = value;
    },
    clearContainerTypeInfo: (state) => {
      state.containerType = initialState.containerType;
    },
  },
});

export const containerTypeDetailSelector = (state) =>
  state.createContainerType.containerType;
export const {
  updateContainerTypeInfo,
  updateContainerTypeInfoField,
  clearContainerTypeInfo,
} = createContainerType.actions;

export const createContainerTypeReducer = createContainerType.reducer;
export const createContainerTypeReducerName = createContainerType.name;

export default createContainerType.reducer;
